module.exports = __webpack_public_path__ + "static/media/giocattolicostumi.2157e20b.png";